import { PortalRequestError } from './portalRequestError';
import { parseSetupPortalState } from './schemas/setupPortalStateSchema';

import type { z } from 'zod';

import type { SetupPortalStateSchema } from './schemas/setupPortalStateSchema';

export type ISetupPortalState = z.infer<typeof SetupPortalStateSchema>;

export async function fetchSetupPortalState(token: string): Promise<ISetupPortalState> {
  const response = await fetch(`/onboard/setup/${token}/state`, {
    headers: { Accept: 'application/json' }
  });
  if (!response.ok) {
    throw new PortalRequestError('Failed to fetch portal state', response.status);
  }
  return parseSetupPortalState(await response.json());
}

export function setupPortalItemUrl(token: string, itemId: number, download = false): string {
  const base = `/onboard/setup/${token}/items/${itemId}`;
  return download ? `${base}?download=1` : base;
}
